module.exports = __webpack_public_path__ + "img/statement.4126d7de.jpeg";